/* WELLIX theme — © 2026 WELLIX */
(function () {
  function q(s, c) { return (c || document).querySelector(s); }
  function qa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* ---------- Clicks (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target, b;
    if ((b = t.closest('[data-menu-toggle]'))) { document.documentElement.classList.toggle('menu-open'); return; }
    if ((b = t.closest('[data-search-toggle]'))) {
      var p = q('[data-search-panel]');
      if (p) { e.preventDefault(); p.classList.toggle('is-open'); var i = q('input[type=search]', p); if (i && p.classList.contains('is-open')) i.focus(); }
      return;
    }
    if ((b = t.closest('[data-qty-minus],[data-qty-plus]'))) {
      var w = b.closest('[data-qty]'), inp = q('input', w);
      var v = parseInt(inp.value, 10) || 1;
      var min = parseInt(inp.getAttribute('min'), 10); if (isNaN(min)) min = 1;
      v = b.hasAttribute('data-qty-plus') ? v + 1 : Math.max(min, v - 1);
      inp.value = v; inp.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if ((b = t.closest('[data-heart]'))) { b.classList.toggle('is-on'); b.setAttribute('aria-pressed', b.classList.contains('is-on')); return; }
    if ((b = t.closest('.wx-thumb'))) {
      var main = q('#wx-main-image');
      if (main) { main.removeAttribute('srcset'); main.src = b.getAttribute('data-full'); main.alt = b.getAttribute('data-alt') || main.alt; }
      qa('.wx-thumb').forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
    }
  });

  /* ---------- Add to Cart (stays on page) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-add-to-cart]');
    if (!b || b.disabled) return;
    var f = b.closest('form'); if (!f) return;
    e.preventDefault();
    var label = b.textContent, fd = new FormData(f);
    fd.delete('return_to');
    b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        qa('.wx-cart-link').forEach(function (a) {
          var c = q('.wx-cart-count', a);
          if (!c) { c = document.createElement('span'); c.className = 'wx-cart-count'; a.appendChild(c); }
          c.textContent = cart.item_count;
        });
        b.textContent = b.getAttribute('data-added') || 'Added';
        setTimeout(function () { b.textContent = label; b.disabled = false; }, 1800);
      })
      .catch(function () {
        b.disabled = false;
        if (f.requestSubmit) f.requestSubmit(b); else f.submit();
      });
  });

  /* ---------- Money ---------- */
  function money(cents, cur) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur || 'USD' }).format(cents / 100); }
    catch (err) { return (cents / 100).toFixed(2); }
  }

  /* ---------- Changes (delegated) ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target, f = t.closest && t.closest('form');
    if (t.name === 'wx_bundle' && f) {
      var qty = q('input[name=quantity]', f); if (qty) qty.value = t.value;
    } else if (t.name === 'quantity' && f) {
      var r = q('input[name=wx_bundle][value="' + t.value + '"]', f);
      if (r) r.checked = true; else qa('input[name=wx_bundle]', f).forEach(function (x) { x.checked = false; });
    } else if (t.name === 'id' && t.tagName === 'SELECT') {
      var sec = t.closest('[data-product-section]'), o = t.options[t.selectedIndex];
      if (!sec || !o) return;
      var price = parseInt(o.getAttribute('data-cents'), 10), cmp = parseInt(o.getAttribute('data-compare'), 10) || 0, cur = sec.getAttribute('data-currency');
      var b2 = parseInt(sec.getAttribute('data-b2'), 10) || 0, b3 = parseInt(sec.getAttribute('data-b3'), 10) || 0;
      var el = q('[data-price]', sec); if (el) el.textContent = money(price, cur);
      var c = q('[data-compare]', sec); if (c) { c.textContent = cmp > price ? money(cmp, cur) : ''; c.style.display = cmp > price ? '' : 'none'; }
      var pc = q('[data-pct]', sec); if (pc) { pc.style.display = cmp > price ? '' : 'none'; if (cmp > price) pc.textContent = Math.round((cmp - price) * 100 / cmp) + '% OFF'; }
      var p1 = q('[data-bundle-price="1"]', sec), p2 = q('[data-bundle-price="2"]', sec), p3 = q('[data-bundle-price="3"]', sec);
      if (p1) p1.textContent = money(price, cur);
      if (p2) p2.textContent = money(Math.round(price * 2 * (100 - b2) / 100), cur);
      if (p3) p3.textContent = money(Math.round(price * 3 * (100 - b3) / 100), cur);
    }
  });

  /* ---------- Before / After slider ---------- */
  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('wx-ba__range')) {
      e.target.closest('.wx-ba').style.setProperty('--pos', e.target.value + '%');
    }
  });

  /* ---------- Timer (evergreen) ---------- */
  function initTimer(el) {
    if (el.getAttribute('data-ready')) return; el.setAttribute('data-ready', '1');
    var dur = (parseInt(el.getAttribute('data-duration'), 10) || 0) * 1000; if (!dur) return;
    var key = 'wellix_offer_end', end = 0;
    try { end = parseInt(localStorage.getItem(key), 10) || 0; } catch (err) {}
    function reset() { end = Date.now() + dur; try { localStorage.setItem(key, String(end)); } catch (err) {} }
    if (end <= Date.now() || end - Date.now() > dur) reset();
    var d = q('[data-d]', el), h = q('[data-h]', el), m = q('[data-m]', el), s = q('[data-s]', el);
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { reset(); left = Math.floor(dur / 1000); }
      d.textContent = pad(Math.floor(left / 86400)); h.textContent = pad(Math.floor(left % 86400 / 3600));
      m.textContent = pad(Math.floor(left % 3600 / 60)); s.textContent = pad(left % 60);
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Live visitors ---------- */
  function initVisitors(el) {
    if (el.getAttribute('data-ready')) return; el.setAttribute('data-ready', '1');
    var min = parseInt(el.getAttribute('data-min'), 10) || 8, max = parseInt(el.getAttribute('data-max'), 10) || 18;
    if (max <= min) max = min + 1;
    var out = q('[data-visitors-count]', el), n = min + Math.floor(Math.random() * (max - min + 1));
    out.textContent = n;
    setInterval(function () {
      n += Math.random() < 0.5 ? -1 : 1; n = Math.max(min, Math.min(max, n)); out.textContent = n;
    }, 4000 + Math.floor(Math.random() * 3000));
  }

  /* ---------- Estimated delivery ---------- */
  function addDays(date, n, skip) {
    var d = new Date(date.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); if (!skip || (d.getDay() !== 0 && d.getDay() !== 6)) n--; }
    return d;
  }
  function initDelivery(el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 3, max = parseInt(el.getAttribute('data-max'), 10) || 7;
    var skip = el.getAttribute('data-skip-weekends') === 'true';
    var out = q('[data-delivery-range]', el); if (!out) return;
    var fmt = { weekday: 'short', month: 'short', day: 'numeric' }, loc = document.documentElement.lang || 'en';
    try {
      var now = new Date();
      out.textContent = addDays(now, min, skip).toLocaleDateString(loc, fmt) + ' – ' + addDays(now, Math.max(max, min), skip).toLocaleDateString(loc, fmt);
    } catch (err) {}
  }

  function init() {
    qa('[data-delivery]').forEach(initDelivery);
    qa('[data-timer]').forEach(initTimer);
    qa('[data-visitors]').forEach(initVisitors);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
